import { render, staticRenderFns } from "./ConclusionStep.vue?vue&type=template&id=70033370&scoped=true"
import script from "./ConclusionStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConclusionStep.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConclusionStep.vue?vue&type=style&index=0&id=70033370&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70033370",
  null
  
)

export default component.exports